import { genMenu } from '@/scripts/router';
import { type Relation } from '@/scripts/utils/tree';
import type { RouteItem } from '@/scripts/router/types';
import { routeMap } from './routeMap';
import Paths from './paths';

export const menuRelation: Relation<RouteItem> = [
  routeMap[Paths.CALLS],
  routeMap[Paths.MESSAGES_PATH],
  routeMap[Paths.FEEDS],
  routeMap[Paths.SHORTS],
  routeMap[Paths.Wallet],
  routeMap[Paths.CONTACTS],
];

export const messageMenuRelation: Relation<RouteItem> = [
  routeMap[Paths.MESSAGES_CHATS],
  routeMap[Paths.MESSAGES_UNREAD],
];

export const personalCenterMenuRelation: Relation<RouteItem> = [
  routeMap[Paths.SETTINGS],
];

export const settingsMenuRelation: Relation<RouteItem> = [
  routeMap[Paths.SETTINGS_NOTIFICATIONS],
  routeMap[Paths.SETTINGS_SECURITY],
  routeMap[Paths.SETTINGS_PRIVACY],
  routeMap[Paths.SETTINGS_ABOUT],
];

export const menu = genMenu(menuRelation);

export const messageMenu = genMenu(messageMenuRelation);

export const personalCenterMenu = genMenu(personalCenterMenuRelation);

export const settingsMenu = genMenu(settingsMenuRelation);
